import { Provider } from '@angular/core';

import { UIStateService } from '../ui-state.service';
import { StateMachineService } from '../state-machine.service';
import { ValidationService } from '../validation.service';
import { BindingDataService } from '../binding-data.service';
import { CommandService } from '../command-service';
import { NavigationMiddlewareService } from '../navigation-middleware.service';
import { GridMiddlewareService } from '../grid.middleware.service';
import { BeActionService } from '../be-action.service';
import { ApproveService } from '../approve.service';
import { PrintService } from '../print.service';
import { AttachmentDataService, AttachmentService, FileService } from '../attachment/index';
import {
  EntityTraversingService, EntityManipulationService, EntityAggregationService,
  EntityListService, EntityService
} from '../entity-services/index';
import { SidebarService } from '../sidebar-service';
import { ChangeItemService } from '../change-item.service';

import {
  ListDataService, CardDataService, SubListDataService, TreeDataService,
  RemoveDataService, SaveDataService, EditDataService, SubTreeDataService
} from '../data-services/index';

import { FarrisFormService } from '../farris-form.service';
import { DialogService } from '../dialog.service';
import { NavigationEventService } from '../navigation-event.service';
import { NavigationService } from '../navigation.service';
import { RouterService } from '../router.service';
import { AuthorityService } from '../authority/authority.service';

import { QuerySolutionService } from '../query-solution/query-solution.service';
import { QUERYSOLUTION_HANDLER_TOKEN } from '@gsp-cmp/querysolution';
import { FilterConditionDataService } from '../data-services/filter-condition-data.service';
import { FocusInvalidService } from '../focus-invalid.service';
import { EndEditService } from '../end-edit.service';
import { RemoteSummaryService } from '../remote-summary.service';
import { BatchEditService } from '../batch-edit.service';
import { BatchEditDialogService } from '@farris/ui-batch-edit-dialog';
import { FeatureEditorService } from '@farris/ui-feature-editor';
import { DiscussionGroupService } from '../discussion-group.service';
import { ListFilterConditionsService } from '../list-filter/list-filter.service';
import { LISTFILTER_HANDLER_TOKEN } from '@farris/ui-list-filter';
import { FORM_MANIFEST_SERVICE_TOKEN, FORM_EXPRESSION_MANIFEST_SERVICE_TOKEN, MESSAGE_SERVICE_TOKEN, NOTIFY_SERVICE_TOKEN, FRAME_COMPONENT_INIT_HANDLER_TOKEN, FORM_ELEMENT_MANIFEST_SERVICE_TOKEN, ELEMENT_MANIFEST_SERVICE_TOKEN } from '@farris/devkit';
import { FormManifestService, FormExpressionManifestService, FormElementManifestService, ElementManifestService } from '../manifest/index';
import { LocalizationService } from '../localization.service';
import { DataGridService } from '../data-grid.service';
import { FormAttentionService } from '../form-attention.service';
import { FeatureDataService, FeatureEditService } from '../feature-edit/index';
import { ExpressionService } from '../expression_service';
import { DirtyCheckingService } from '../dirty-checking.service';
import { FormMessageService } from '../form-message.service';
import { FormNotifyService } from '../form-notify.service';
import { PopUpService } from '../pop_up.service';
import { WorkFlowMessageHandler } from '../work-flow/index';
import { FormService } from '../form.service';
import { FormControlService } from '../form-control.service';
import { BindingPathService } from '../binding-path.service';
import { FrameContextService } from '../frame-context.service';
import { ViewModelService } from '../view-model.service';
import { PaginationService } from '../pagination.service';
import { RUNTIME_FRAMEWORK_CONTEXT_TOKEN } from '@farris/devkit';
import { RuntimeFrameworkContextService, runtimeFrameworkContextFactory } from '../session/index';
import { DataCheckService } from '../data-check.service';
/**
 * ç»ä»¶çº§æ³¨å¥æ³¨å¥(å±23ä¸ª)
 */
const FARRIS_COMMAND_SERVICE_FRAME_PROVIDERS: Provider[] = [
  ValidationService,
  FocusInvalidService,
  ChangeItemService,
  UIStateService,
  StateMachineService,
  BindingDataService,
  CommandService,

  // entity-services
  EntityTraversingService,
  EntityManipulationService,
  EntityAggregationService,
  EntityListService,
  EntityService,

  // data-services
  ListDataService,
  TreeDataService,
  SubTreeDataService,
  CardDataService,
  SubListDataService,
  RemoveDataService,
  SaveDataService,
  EditDataService,
  FilterConditionDataService,
  RemoteSummaryService,

  BeActionService,
  ApproveService,
  PrintService,
  AttachmentDataService,
  AttachmentService,
  FileService,
  NavigationMiddlewareService,
  GridMiddlewareService,
  SidebarService,
  FarrisFormService,
  DialogService,
  NavigationEventService,
  NavigationService,
  RouterService,
  AuthorityService,
  {
    provide: QUERYSOLUTION_HANDLER_TOKEN,
    useClass: QuerySolutionService
  },
  {
    provide: LISTFILTER_HANDLER_TOKEN,
    useClass: ListFilterConditionsService
  },
  EndEditService,
  BatchEditDialogService,
  BatchEditService,
  DiscussionGroupService,
  LocalizationService,
  DataGridService,
  FormAttentionService,
  FeatureEditorService,
  FeatureDataService,
  FeatureEditService,
  ExpressionService,
  PopUpService,
  DirtyCheckingService,
  FormService,
  FormControlService,
  BindingPathService,
  FrameContextService,
  ViewModelService,
  PaginationService,
  DataCheckService,
  // è¡¨è¾¾å¼
  { provide: FORM_MANIFEST_SERVICE_TOKEN, useClass: FormManifestService },
  { provide: FORM_EXPRESSION_MANIFEST_SERVICE_TOKEN, useClass: FormExpressionManifestService },
  { provide: MESSAGE_SERVICE_TOKEN, useClass: FormMessageService },
  { provide: NOTIFY_SERVICE_TOKEN, useClass: FormNotifyService },
  { provide: FRAME_COMPONENT_INIT_HANDLER_TOKEN, useClass: WorkFlowMessageHandler, multi: true },
  // çé¢è§åå è½½æå¡
  { provide: FORM_ELEMENT_MANIFEST_SERVICE_TOKEN, useClass: FormElementManifestService },
  { provide: ELEMENT_MANIFEST_SERVICE_TOKEN, useClass: ElementManifestService },
  // æ¡æ¶ä¼è¯ä¿¡æ¯
  RuntimeFrameworkContextService,
  { provide: RUNTIME_FRAMEWORK_CONTEXT_TOKEN, useFactory: runtimeFrameworkContextFactory, deps: [RuntimeFrameworkContextService] }

];

export { FARRIS_COMMAND_SERVICE_FRAME_PROVIDERS };
